<template>
	<svg
		id="custom_svg_lib"
		width="21.847656"
		height="21.846924"
		viewBox="0 0 21.8477 21.8469"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		
	>
		<desc>Created with Pixso.</desc>
		<defs />
		<circle id="Ellipse 1" cx="10.923828" cy="10.923462" r="10.923489" fill="#FF6D2E" fill-opacity="1.000000" />
		<path
			id="Vector"
			d="M12.38 15.9L12.89 15.39C12.96 15.33 13 15.25 13 15.16C13 15.08 12.96 15 12.89 14.93L8.84 11L12.89 7.06C12.96 6.99 13 6.91 13 6.83C13 6.74 12.96 6.66 12.89 6.6L12.38 6.1C12.31 6.03 12.23 6 12.14 6C12.05 6 11.97 6.03 11.9 6.1L7.1 10.76C7.03 10.83 7 10.91 7 11C7 11.08 7.03 11.16 7.1 11.23L11.9 15.9C11.97 15.96 12.05 16 12.14 16C12.23 16 12.31 15.96 12.38 15.9Z"
			fill="#F2F7FF"
			fill-opacity="1.000000"
			fill-rule="nonzero"
		/>
	</svg>
</template>
